import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AjaxService } from 'src/app/service/ajax.service';
import { API } from 'src/environments/environment';

@Component({
  selector: 'app-cadastro-mentorado',
  templateUrl: './cadastro-mentorado.component.html',
  styleUrls: ['./cadastro-mentorado.component.scss']
})
export class CadastroMentoradoComponent implements OnInit {
  @ViewChild('formModal') formModal!: TemplateRef<any>;
  @ViewChild('buscaMentoresModal') buscaMentoresModal!: TemplateRef<any>;

  cadastroForm: FormGroup;
  mentorados: any[] = [];
  mentoradosFiltrados: any[] = [];
  mentoradoSelecionado: any = null;
  modalRef!: NgbModalRef;

  // Filtros
  filtroNome: string = '';
  filtroEmail: string = '';
  filtroTelefone: string = '';

  // Busca de mentores
  buscandoMentores: boolean = false;
  mentoresEncontrados: any[] = [];
  modalRefBusca!: NgbModalRef;

  // Máscaras
  cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
  telefoneMask = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private ajaxService: AjaxService
  ) {
    this.cadastroForm = this.fb.group({
      // Dados Pessoais
      NOME: ['', Validators.required],
      TELEFONE: ['', Validators.required],
      EMAIL: ['', [Validators.required, Validators.email]],
      
      // Dados do Projeto
      CURSO_GRADUACAO: ['', Validators.required],
      NIVEL_FORMACAO: ['', Validators.required],
      PROGRAMA_POS_GRADUACAO: [''],
      INSTITUICAO_ENSINO: ['', Validators.required],
      
             // Dados do Projeto
       NOME_PROJETO: ['', Validators.required],
       ORIENTADOR: ['', Validators.required],
       CO_ORIENTADOR: [''],
       TIPO_PROJETO: ['', Validators.required],
       ESTAGIO_PROJETO: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.carregarMentorados();
    this.preencherValoresDefault();
  }

  carregarMentorados(): void {
    this.ajaxService.get(API + 'Mentorado/Mentorado').subscribe({
      next: (response) => {
        if (response && response.data.length > 0) {
          this.mentorados = response.data;
          this.mentoradosFiltrados = [...this.mentorados];
        }
      },
      error: (error) => {
        console.error('Erro ao carregar mentorados:', error);
      }
    });
  }

  openModal(modal: any, isNew: boolean = false): void {
    if (isNew) {
      this.mentoradoSelecionado = null;
      this.cadastroForm.reset();
    }
    this.modalRef = this.modalService.open(modal, { size: 'lg', centered: true });
  }

     editarMentorado(mentorado: any): void {
     this.mentoradoSelecionado = mentorado;
     this.cadastroForm.patchValue({
       NOME: mentorado.nome,
       TELEFONE: mentorado.telefone,
       EMAIL: mentorado.email,
       CURSO_GRADUACAO: mentorado.cursoGraduacao,
       NIVEL_FORMACAO: mentorado.nivelFormacao,
       PROGRAMA_POS_GRADUACAO: mentorado.programaPosGraduacao,
       INSTITUICAO_ENSINO: mentorado.instituicaoEnsino,
       NOME_PROJETO: mentorado.nomeProjeto,
       ORIENTADOR: mentorado.orientador,
       CO_ORIENTADOR: mentorado.coOrientador,
       TIPO_PROJETO: mentorado.tipoProjeto,
       ESTAGIO_PROJETO: mentorado.estagioProjeto
     });
   }

     onSubmit(): void {
     if (this.cadastroForm.valid) {
       const dados = this.cadastroForm.value;
       
       // Simular salvamento
       console.log('Dados do formulário:', dados);
       
       // Iniciar busca de mentores
       this.buscarMentores();
     }
   }

  limparFormulario(): void {
    this.cadastroForm.reset();
    this.mentoradoSelecionado = null;
  }

     preencherValoresDefault(): void {
     this.cadastroForm.patchValue({
       NOME: 'Maria',
       TELEFONE: '(11) 99999-9999',
       EMAIL: 'maria@email.com',
       CURSO_GRADUACAO: 'Engenharia de Software',
       NIVEL_FORMACAO: 'Graduacao',
       PROGRAMA_POS_GRADUACAO: 'Programa de Pós-Graduação em Informática e Tecnologia',
       INSTITUICAO_ENSINO: 'Universidade Federal de São Paulo',
       NOME_PROJETO: 'Sistema de Gestão de Projetos Acadêmicos',
       ORIENTADOR: 'Dr. João Silva',
       CO_ORIENTADOR: 'Dra. Ana Santos',
       TIPO_PROJETO: 'TCC',
       ESTAGIO_PROJETO: 'Planejamento'
     });
   }

  aplicarFiltros(): void {
    this.mentoradosFiltrados = this.mentorados.filter(mentorado => {
      const nomeMatch = !this.filtroNome || 
        mentorado.nome?.toLowerCase().includes(this.filtroNome.toLowerCase());
      const emailMatch = !this.filtroEmail || 
        mentorado.email?.toLowerCase().includes(this.filtroEmail.toLowerCase());
      const telefoneMatch = !this.filtroTelefone || 
        mentorado.telefone?.includes(this.filtroTelefone);
      
      return nomeMatch && emailMatch && telefoneMatch;
    });
  }

     limparFiltros(): void {
     this.filtroNome = '';
     this.filtroEmail = '';
     this.filtroTelefone = '';
     this.mentoradosFiltrados = [...this.mentorados];
   }

       buscarMentores(): void {
      this.buscandoMentores = true;
      this.mentoresEncontrados = [];
      
      // Abrir modal primeiro
      this.abrirModalBusca();
      
      // Simular delay de busca
      setTimeout(() => {
        this.mentoresEncontrados = [
          {
            nome: 'Andreas Flugs',
            titulo: 'Dr. em Engenharia de Software',
            instituicao: 'Universidade Federal de São Paulo',
            matchScore: 95,
            areas: ['Engenharia de Software', 'Inteligência Artificial', 'Desenvolvimento Web'],
            experiencia: '15+ anos em desenvolvimento de software e pesquisa acadêmica',
            projetosOrientados: 23,
            descricao: 'Especialista em metodologias ágeis, arquitetura de software e machine learning. Já orientou mais de 20 projetos de TCC e mestrado com foco em tecnologias inovadoras.'
          },
          {
            nome: 'Frederico Mendes',
            titulo: 'Dr. em Ciência da Computação',
            instituicao: 'Universidade de São Paulo',
            matchScore: 87,
            areas: ['Ciência da Computação', 'Sistemas Distribuídos', 'Cloud Computing'],
            experiencia: '12+ anos em pesquisa e desenvolvimento de sistemas distribuídos',
            projetosOrientados: 18,
            descricao: 'Pesquisador com vasta experiência em sistemas distribuídos, computação em nuvem e arquiteturas escaláveis. Especialista em tecnologias emergentes e metodologias de pesquisa.'
          },
          {
            nome: 'Luciana Lima',
            titulo: 'Dra. em Informática',
            instituicao: 'Universidade Estadual de Campinas',
            matchScore: 92,
            areas: ['Informática', 'Interação Humano-Computador', 'UX/UI Design'],
            experiencia: '10+ anos em design de interfaces e experiência do usuário',
            projetosOrientados: 31,
            descricao: 'Especialista em design de interfaces, experiência do usuário e metodologias de design thinking. Já orientou diversos projetos focados em usabilidade e acessibilidade.'
          }
        ];
        
        this.buscandoMentores = false;
      }, 3000); // 3 segundos de simulação
    }

    abrirModalBusca(): void {
      // Usar NgbModal para abrir o modal usando o template
      this.modalRefBusca = this.modalService.open(this.buscaMentoresModal, { 
        size: 'lg', 
        centered: true,
        backdrop: 'static',
        keyboard: false
      });
    }

    fecharModalBusca(): void {
      if (this.modalRefBusca) {
        this.modalRefBusca.close();
      }
    }
}
